import React from "react";
import clsx from "clsx";
import { Arrow as ArrowIcon } from "~/components/icons/arrow";
import { ChevronIcon } from "~/components/icons/chevron";
import { useScreenSize } from "~/utils/layout";

import * as styles from "./index.module.scss";

/*
  SETTINGS
  layout: style of button
    - secondary is white background
    - tertiary is transparent background
  disabled: passed in {..rest}
  small/big : this overrides the media defined size
 */
export const DLSButton = React.forwardRef(
  (
    {
      onClick,
      label = "",
      children = "",
      customClass = "",
      layout = "primary",
      withChevron = "",
      small = false,
      big = false,
      Icon = null,
      viewBox = null,
      type = "button",
      useChevron = false,
      ...rest
    },
    ref,
  ) => {
    const Arrow =
      useScreenSize(["mini", "small"]) || useChevron ? ChevronIcon : ArrowIcon;

    return (
      <button
        // eslint-disable-next-line react/button-has-type
        type={type}
        onClick={onClick}
        className={clsx(
          styles.button,
          styles[layout],
          small && styles.small,
          customClass,
        )}
        ref={ref}
        {...rest}
      >
        {/* TODO: ArrowIcon direction left seems to be broken. I make a fix to rotate right icon instead of render left icnon. Change to direction="left" after its fixed  */}
        {withChevron === "left" && (
          <Arrow
            direction="right"
            small
            viewBox={viewBox}
            className={clsx(
              styles.chevron,
              styles.chevronLeft,
              styles[withChevron],
            )}
          />
        )}
        {label || children}
        {withChevron === "right" && (
          <Arrow direction="right" small className={styles.chevron} />
        )}
        {withChevron === "down" && (
          <ChevronIcon
            direction="down"
            small
            viewBox={viewBox}
            className={styles.chevron}
          />
        )}
        {Icon && <Icon />}
      </button>
    );
  },
);

DLSButton.displayName = "DLSButton";
